module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.9a7ef89.woff2";